module.exports = __webpack_public_path__ + "static/media/018.b74002ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/018.jpg
// module id = 315
// module chunks = 0